import { useState } from 'react';

import { isValidEmail } from '@/helpers/validations';

export const useAlertModal = () => {
  const [email, setEmail] = useState('');
  const [isInvalidEmail, setIsInvalidEmail] = useState(false);

  const handleEmailOnChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    setEmail(event.target.value);
  };

  const validationBeforeCreateAlert = (): boolean => {
    if (isValidEmail(email)) {
      setIsInvalidEmail(false);
      return true;
    }

    setIsInvalidEmail(true);
    return false;
  };

  return {
    email,
    isInvalidEmail,
    onEmailChange: handleEmailOnChange,
    onValidate: validationBeforeCreateAlert,
  };
};
